import axios from "axios";
import variables from "globals/variables";
import SIPPhoneService from "application/components/SIPPhone/SIPPhoneService";
import loggerFactory from "globals/logger/logger-factory";
import CryptoJS from "crypto-js";
const componentName = "AuthenticationService";

const appLogWS = (message) => {
  console.log("Message Received at Application Endpoint");
  console.log(JSON.parse(message.body));
};

const telemetryLogWS = (message) => {
  console.log("Message Received at Telemetry Endpoint");
  console.log(JSON.parse(message.body));
};

class AuthenticationStatus {
  constructor() {
    loggerFactory.info("Authentication", "Page reloaded");
    this.currentUser = this.getUserName();

    if (this.currentUser) {
      this.startNotifications();
    }
  }

  loginTriggered() {
    loggerFactory.info("Authentication", "Login triggered");
    this.startNotifications();
  }

  getUserId() {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-User-Id`,
    );
  }

  getUserName() {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-UserName`,
    );
  }

  startNotifications() {
    loggerFactory.info(
      "Authentication Manager",
      `Starting notifications for ${this.currentUser}`,
    );
  }
}

const AuthenticationManager = new AuthenticationStatus();

const AuthenticationService = {
  nmsCallBacks: new Map(),
  serviceCallBacks: new Map(),
  telemetryCallBacks: new Map(),
  mcxCallBacks: new Map(),
  routeCoordinateCallBacks: new Map(),
  dispatcherCallBacks: new Map(),

  storeAuthenticationDetails: function (
    sipPhoneButton,
    token,
    refreshToken,
    userName,
    fullName,
    roles,
    menus,
    coralApplication,
    sipDetails,
    rluCode,
    rluIP,
    pwdComplication,
    userId,
    ringAnswerCount,
    publicEmergencyNumber,
    broadcastNumber,
    wssDomain,
    mapUrl,
    mapCenter,
    mapDefaultZoom,
    mapMinZoom,
    mapMaxZoom,
    xmPPPrimaryDomain,
    departmentList,
    idealTimeout,
    description,
    appMode,
    enableTTS,
    disableContextBasedGui,
    turnServerUrl,
    turnUserName,
    turnPassword,
    currencyConfig,
  ) {
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-SIP-PhoneButton`,
      JSON.stringify(sipPhoneButton),
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Token`,
      token,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Refresh-Token`,
      refreshToken,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-User-Id`,
      userId,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-UserName`,
      userName,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-FullName`,
      fullName ?? "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Roles`,
      roles,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Menus`,
      JSON.stringify(menus),
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Apps`,
      JSON.stringify(coralApplication),
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-SIP`,
      JSON.stringify(sipDetails),
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-RLUCode`,
      rluCode,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-RLUIp`,
      rluIP,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-PasswordComplexity`,
      pwdComplication,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Change-Password-Required`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Answer-Ring-Count`,
      ringAnswerCount,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Public-Emergency-Number`,
      publicEmergencyNumber,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Broadcast-Number`,
      broadcastNumber,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-SIP-Domain`,
      wssDomain,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Map-Url`,
      mapUrl,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Map-Center`,
      mapCenter,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Map-Default-Zoom`,
      mapDefaultZoom,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Map-Min-Zoom`,
      mapMinZoom,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Map-Max-Zoom`,
      mapMaxZoom,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Xmpp-Primary-Domain`,
      xmPPPrimaryDomain,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Department-List`,
      JSON.stringify(departmentList || []),
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Ideal-Timeout`,
      idealTimeout,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Description`,
      description ?? "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-App-Mode`,
      appMode,
    );

    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-ENABLE-TTS`,
      enableTTS
    );

    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-DisableContextBasedGui`,
      disableContextBasedGui ? "true" : "false"
    );

    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Turn-Server-Url`,
      turnServerUrl
    );

    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Turn-User-Name`,
      turnUserName
    );

    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Turn-Password`,
      turnPassword
    );

    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Currency-Config`,
      JSON.stringify(currencyConfig || {})
    );

    AuthenticationManager.loginTriggered();

    this.updateSIP();
    loggerFactory.info(componentName, "login success");
  },

  getXmppPrimaryDomain: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Xmpp-Primary-Domain`,
    );
  },

  getPasswordComplexity: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-PasswordComplexity`,
    );
  },

  getIdealTimeout: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Ideal-Timeout`,
    );
  },

  getDepartmentList: function () {
    const departmentList = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Department-List`,
    );
    if (departmentList && departmentList !== "undefined") {
      try {
        return JSON.parse(departmentList);
      } catch (e) {
        return [];
      }
    } else {
      return [];
    }
  },

  getSipPhoneButton: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-SIP-PhoneButton`,
    );
  },

  getAuthenticationToken: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Token`,
    );
  },
  getRefreshToken: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Refresh-Token`,
    );
  },
  setRefreshedToken: function (token, refreshToken) {
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Token`,
      token,
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Refresh-Token`,
      refreshToken,
    );
  },
  setUserId: function (userId) {
    return window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-User-Id`,
      userId,
    );
  },
  getUserId: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-User-Id`,
    );
  },

  setUserName: function (userName) {
    return window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-UserName`,
      userName,
    );
  },
  getUserName: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-UserName`,
    );
  },

  getUser: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-User`,
    );
  },

  getAutoAnswerRingCount: function () {
    let AutoAnswerRingCount = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Answer-Ring-Count`,
    );
    return AutoAnswerRingCount ? AutoAnswerRingCount : 0;
  },

  getPublicEmergencyNumber: function () {
    let publicEmergencyNumber = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Public-Emergency-Number`,
    );
    return publicEmergencyNumber;
  },

  getBroadcastNumber: function () {
    let broadcastNumber = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Broadcast-Number`,
    );
    return broadcastNumber;
  },

  getMapUrl: function () {
    let mapUrl = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Map-Url`,
    );
    return mapUrl;
  },
  getMapCenter: function () {
    let storedMapCenter = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Map-Center`,
    );

    if (storedMapCenter) {
      let returnValue = [
        storedMapCenter.split(",")[0] * 1,
        storedMapCenter.split(",")[1] * 1,
      ];
      return returnValue;
    }
    return null;
  },
  getMapDefaultZoom: function () {
    let mapDefaultZoom = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Map-Default-Zoom`,
    );
    return mapDefaultZoom;
  },
  getMapMinZoom: function () {
    let mapMinZoom = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Map-Min-Zoom`,
    );
    return mapMinZoom;
  },
  getMapMaxZoom: function () {
    let mapMaxZoom = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Map-Max-Zoom`,
    );
    return mapMaxZoom;
  },

  getSipDomain: function () {
    let wssDomain = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-SIP-Domain`,
    );
    return wssDomain;
  },

  getSIPDetails: function () {
    let sipDetails = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-SIP`,
    );
    if (!sipDetails) {
      sipDetails = {
        extensionName: "",
        extension: "",
        sipPassword: "",
      };
    }
    return sipDetails;
  },

  getUserDescription: function () {
    let description = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Description`,
    );
    return description ? description : "";
  },

  getTTS: function () {
    let enableTTS = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-ENABLE-TTS`,
    );
    return enableTTS ? enableTTS : "";
  },

  isContextBasedGuiDisabled: function () {
    return (
      window.sessionStorage.getItem(
        `${window.location.hostname}-coral-X-DisableContextBasedGui`,
      ) === "true"
    );
  },

  getTurnServerUrl: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Turn-Server-Url`
    );
  },

  getTurnUserName: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Turn-User-Name`
    );
  },

  getTurnPassword: function () {
    return window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Turn-Password`
    );
  },

  getCurrencyConfig: function () {
    const raw = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Currency-Config`
    );
    if (raw && raw !== "undefined") {
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }
    return null;
  },

  getAppMode: function () {
    const appMode = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-App-Mode`,
    );

    if (
      appMode === null ||
      appMode === "undefined" ||
      appMode === "" ||
      appMode === undefined
    ) {
      return 0;
    }

    const parsed = Number(appMode);
    return Number.isNaN(parsed) ? 0 : parsed;
  },
  getFullName: function () {
    let fullName = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-FullName`,
    );
    return fullName ? fullName : "";
  },
  getExtensionNumber: function () {
    let sipDetails = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-SIP`,
    );

    return sipDetails ? JSON.parse(sipDetails).extension : "";
  },

  getKeyTypePage: function () {
    const storedKey = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Page-Type`,
    );
    if (storedKey) {
      return true;
    } else {
      return false;
    }
  },

  getGroupMenus: function () {
    let returnValue = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Menus`,
    );

    if (returnValue) {
      return JSON.parse(returnValue);
    } else {
      return [];
    }
  },

  getApps: function () {
    let returnValue = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Apps`,
    );
    if (returnValue) {
      return JSON.parse(returnValue);
    } else {
      return [];
    }
  },

  logout: function () {
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-SIP-PhoneButton`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-User`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Token`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Refresh-Token`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-User-Id`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-UserName`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-FullName`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Roles`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Menus`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Apps`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-SIP`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-RLUCode`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-RLUIp`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-PasswordComplexity`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Change-Password-Required`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Answer-Ring-Count`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Public-Emergency-Number`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Broadcast-Number`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Map-Url`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Map-Center`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Map-Default-Zoom`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Map-Max-Zoom`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Map-Min-Zoom`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-SIP-Domain`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Xmpp-Primary-Domain`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Department-List`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Ideal-Timeout`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Description`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-App-Mode`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-ENABLE-TTS`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-DisableContextBasedGui`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Turn-Server-Url`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Turn-User-Name`,
      "",
    );
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Turn-Password`,
      "",
    );

    SIPPhoneService.isInitDone = false;
    SIPPhoneService.userAgentOptions.displayName = "";
    SIPPhoneService.userAgentOptions.authorizationUsername = "";
    SIPPhoneService.userAgentOptions.authorizationPassword = "";
  },
  login: function (userName, password) {
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-User`,
      userName,
    );
    return axios.post(variables.app.services + "auth/login", {
      username: userName,
      password: password,
    });
  },
  getProductName: function () {
    return axios.get(variables.app.services + "product-name");
  },
  ChangePassword: function (data) {
    return axios.post(variables.app.services + "auth/changePassword", data);
  },
  isAuthenticated: function () {
    let currentUser = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-User`,
    );

    return currentUser ? true : false;
  },
  allowApps() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles.includes("ROLE_PROVISIONING");
  },
  allowConferenceMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_UC_CONFERENCE_MODERATOR");
  },

  allowOCADMIN() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_OCADMIN");
  },

  allowUCConferenceMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_CONFERENCE");
  },

  allowEnableUCConference() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_ENABLE_UC_CONFERENCE");
  },

  // Single source of truth for the UC conference menu keys gated by
  // ROLE_ENABLE_UC_CONFERENCE. Returns true when the given menu key is a
  // conference entry that must be hidden (not disabled) for the current user.
  ucConferenceMenuKeys: [
    "uc.conference.calendar",
    "uc.conference.setting",
    "uc.conference.recording",
  ],

  isUCConferenceMenuHidden(key) {
    if (!AuthenticationService.ucConferenceMenuKeys.includes(key)) {
      return false;
    }
    return !AuthenticationService.allowEnableUCConference();
  },

  allowGroupAdmin() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_GROUP_ADMIN");
  },

  allowUCMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_USERS");
  },

  // Normalized (split-token) role reader for the roleLandingConfig resolver.
  // Distinct from the allowXxx() substring helpers above, which are left
  // unchanged for their existing non-landing call sites.
  getNormalizedRoles() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    if (!roles) {
      return [];
    }
    return String(roles)
      .split(",")
      .map((role) => role.trim())
      .filter(Boolean);
  },

  hasNormalizedRole(role) {
    return AuthenticationService.getNormalizedRoles().includes(role);
  },

  hasExactNormalizedRoles(roles) {
    const normalizedRoles = AuthenticationService.getNormalizedRoles();
    if (normalizedRoles.length !== roles.length) {
      return false;
    }
    return roles.every((role) => normalizedRoles.includes(role));
  },

  allowCustomucMenu() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_ARVINDTELECOM");
  },

  allowEamsMenu() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_EAMS");
  },

  allowRailwayDispatcher() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_RAILWAY_DISPATCHER");
  },

  allowMCXDispatcher() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_MCX_DISPATCHER");
  },

  allowROIDUser() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_ROID");
  },

  allowExternalCRM() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_EXTERNAL_CRM");
  },

  allowChat() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_CHAT");
  },

  allowhmsAdminMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_HOTEL");
  },
  allowkmAdminMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_KMADMIN");
  },
  allowManagerMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_MANAGER");
  },
  allownmsMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_NMS_USER");
  },
  allownmsViewerMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_NMS_VIEWER");
  },

  allowActiveAlerts() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_ACTIVE_ALERT");
  },

  allowOperatorSupervisor() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_OPERATOR_SUPERVISOR");
  },

  allowACDSupervisor() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_ACD_SUPERVISOR");
  },

  allownmsAdminMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_NMSADMIN");
  },
  allowsurakshaMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_SURAKSHA");
  },
  allowAdminMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return (
      roles &&
      (roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_APW_ADMIN") ||
        roles.includes("ROLE_CPW_ADMIN") ||
        roles.includes("ROLE_OPW_ADMIN") ||
        roles.includes("ROLE_EDP_ADMIN") ||
        roles.includes("ROLE_PBX_MANAGER") ||
        roles.includes("ROLE_PBX_VIEWER") ||
        roles.includes("ROLE_PBX_SYSTEM_VIEWER") ||
        roles.includes("ROLE_ALLPBXMENUVIEWER") ||
        roles.includes("ROLE_ALLPBXSYSTEMVIEWER"))
    );
  },
  allowTaskUserManager() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_TASKUSER");
  },
  allowTaskManager() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_TASKMANAGER");
  },
  allowVoicePickerMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_PICKER");
  },
  allowCodeBlueViewerMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_CODEBLUE_VIEWER");
  },
  allowDashboardConfigMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_ANALYTICS");
  },
  allowBillingMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_BILLING");
  },
  isViewOnlyUser() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    if (!roles) return false;
    return (
      roles.includes("ROLE_PBX_VIEWER") ||
      roles.includes("ROLE_PBX_SYSTEM_VIEWER") ||
      roles.includes("ROLE_ALLPBXMENUVIEWER") ||
      roles.includes("ROLE_ALLPBXSYSTEMVIEWER")
    );
  },
  isBillingOnlyUser() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    if (!roles || !roles.includes("ROLE_BILLING")) return false;
    const elevated = [
      "ROLE_ADMIN",
      "ROLE_APW_ADMIN",
      "ROLE_CPW_ADMIN",
      "ROLE_OPW_ADMIN",
      "ROLE_EDP_ADMIN",
      "ROLE_USERS",
      "ROLE_AGENT",
      "ROLE_TEAMLEADER",
      "ROLE_MANAGER",
      "ROLE_OCADMIN",
      "ROLE_ANALYTICS",
      "ROLE_NMSADMIN",
      "ROLE_NMS_USER",
      "ROLE_NMS_VIEWER",
      "ROLE_NMSVIEWER",
      "ROLE_ACD_SUPERVISOR",
      "ROLE_OPERATOR_SUPERVISOR",
      "ROLE_OPERATOR_ADMIN",
    ];
    return !elevated.some((r) => roles.includes(r));
  },
  allowOperatorAdminMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_OPERATOR_ADMIN");
  },
  isOperatorAdminOnlyUser() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    if (!roles || !roles.includes("ROLE_OPERATOR_ADMIN")) return false;
    const elevated = [
      "ROLE_ADMIN",
      "ROLE_APW_ADMIN",
      "ROLE_CPW_ADMIN",
      "ROLE_OPW_ADMIN",
      "ROLE_EDP_ADMIN",
      "ROLE_USERS",
      "ROLE_AGENT",
      "ROLE_TEAMLEADER",
      "ROLE_MANAGER",
      "ROLE_OCADMIN",
      "ROLE_ANALYTICS",
      "ROLE_NMSADMIN",
      "ROLE_NMS_USER",
      "ROLE_NMS_VIEWER",
      "ROLE_NMSVIEWER",
      "ROLE_ACD_SUPERVISOR",
      "ROLE_OPERATOR_SUPERVISOR",
      "ROLE_BILLING",
    ];
    return !elevated.some((r) => roles.includes(r));
  },
  allowkanAdminMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_KANADMIN");
  },

  allowAgentMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );

    return roles && roles.includes("ROLE_AGENT");
  },
  allowCallcenterTabMenus() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_TEAMLEADER");
  },
  allowUserApplication() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return (
      roles &&
      (roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_USERS") ||
        roles.includes("ROLE_AGENT") ||
        roles.includes("ROLE_TEAMLEADER") ||
        roles.includes("ROLE_ACD_SUPERVISOR") ||
        roles.includes("ROLE_OPERATOR_SUPERVISOR") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_OCADMIN"))
    );
  },
  allowPAMenu() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_PA");
  },
  allowEngineerMenu() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_ENGINEER");
  },
  allowDepartmentHeadMenu() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_DEPTHEAD");
  },
  allowApollo() {
    let roles = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Roles`,
    );
    return roles && roles.includes("ROLE_APOLLO");
  },
  allowIccc() {
    return this.isAuthenticated();
  },
  allowPhone() {
    // let sipDetails = JSON?.parse(
    //   window.sessionStorage.getItem(`${window.location.hostname}-coral-X-SIP`)
    // );

    const rawData = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-SIP`,
    );

    if (!rawData) return null;
    let sipDetails = JSON.parse(rawData);

    return sipDetails.extension;
  },

  updateSIP() {
    if (this.isAuthenticated()) {
      let storedSIPDetails = window.sessionStorage.getItem(
        `${window.location.hostname}-coral-X-SIP`,
      );
      let sipDetails = storedSIPDetails ? JSON.parse(storedSIPDetails) : null;

      const decryptData = (encryptedData, secretKey) => {
        const encryptedWordArray = CryptoJS.enc.Base64.parse(encryptedData);
        const iv = CryptoJS.lib.WordArray.create(
          encryptedWordArray.words.slice(0, 4),
          16,
        );
        const ciphertext = CryptoJS.lib.WordArray.create(
          encryptedWordArray.words.slice(4),
          encryptedWordArray.sigBytes - 16,
        );
        const decrypted = CryptoJS.AES.decrypt(
          { ciphertext: ciphertext },
          CryptoJS.enc.Utf8.parse(secretKey),
          { iv: iv, mode: CryptoJS.mode.CFB, padding: CryptoJS.pad.Pkcs7 },
        );
        const value = decrypted.toString(CryptoJS.enc.Utf8);
        loggerFactory.info("SIP Password ", value);
        return value;
      };

      if (sipDetails && sipDetails.extension) {
        SIPPhoneService.enabled = true;
        SIPPhoneService.isInitDone = false;
        SIPPhoneService.deskPhoneStatus = this.getDeskPhoneStatus();
        SIPPhoneService.userAgentOptions.displayName = sipDetails.extensionName;
        SIPPhoneService.userAgentOptions.authorizationUsername =
          sipDetails.extension;
        SIPPhoneService.userAgentOptions.authorizationPassword = decryptData(
          sipDetails.sipPassword,
          window.secretKey,
        );
        SIPPhoneService.init();
      } else {
        SIPPhoneService.enabled = false;
      }
    }
  },
  getDeskPhoneStatus() {
    let currentUser = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-User`,
    );

    let deskPhoneEnabled = window.localStorage.getItem(
      `${window.location.hostname}-userPreference-${currentUser}-deskPhone`,
    );

    if (window.clickToCall) {
      return "N";
    }

    let returnValue = deskPhoneEnabled === "Y";

    return returnValue;
  },
  setDeskPhoneStatus(status) {
    let currentUser = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-User`,
    );

    let deskPhoneEnabled = window.localStorage.setItem(
      `${window.location.hostname}-userPreference-${currentUser}-deskPhone`,
      status ? "Y" : "N",
    );

    window.location.reload();

    return deskPhoneEnabled == "Y";
  },
  getLocation: function () {
    let storedLocation = window.localStorage.getItem(
      `${window.location.hostname}-coral-X-LOCATION`,
    );

    if (storedLocation) {
      let returnValue = [
        storedLocation.split(",")[0] * 1,
        storedLocation.split(",")[1] * 1,
      ];
      return returnValue;
    } else {
      return window.mapCenter;
    }

    return null;
  },
  setLocation: function (xCoordinate, yCoordinate) {
    window.localStorage.setItem(
      `${window.location.hostname}-coral-X-LOCATION`,
      [xCoordinate, yCoordinate],
    );
  },

  setChangePasswordRequired: function (changePasswordRequired) {
    window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-Change-Password-Required`,
      changePasswordRequired,
    );
  },

  getLastViewDashboardId: function () {
    let user = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-UserName`,
    );
    return window.localStorage.getItem(
      `${window.location.hostname}-${user}-LastViewed-DashboardId`,
    );
  },

  setLastViewDashboardId: function (dashboardId) {
    let user = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-UserName`,
    );
    window.localStorage.setItem(
      `${window.location.hostname}-${user}-LastViewed-DashboardId`,
      dashboardId,
    );
  },

  getLastDialNumber: function () {
    let user = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-UserName`,
    );
    return window.localStorage.getItem(
      `${window.location.hostname}-${user}-LastDial-Number`,
    );
  },

  setLastDialNumber: function (number) {
    let user = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-UserName`,
    );
    window.localStorage.setItem(
      `${window.location.hostname}-${user}-LastDial-Number`,
      number,
    );
  },

  setActiveSessionForCallBarging: function (data) {
    console.log("bargingdatadtadatadta", data);
    return window.sessionStorage.setItem(
      `${window.location.hostname}-coral-X-ActiveSessionForCallBarging`,
      JSON.stringify(data),
    );
  },
  getActiveSessionForCallBarging: function () {
    const data = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-ActiveSessionForCallBarging`,
    );
    return data ? JSON.parse(data) : null;
  },
  getRluCode: function () {
    let code = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-RLUCode`,
    );
    return code;
  },

  getRluIp: function () {
    let rluIp = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-RLUIp`,
    );
    return rluIp;
  },

  getRLUIpAddress: function () {
    let returnValue = "";
    returnValue = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-RLUIp`,
    );

    if (!returnValue) {
      returnValue = window.callServer;
    }

    if (!returnValue) {
      returnValue = window.location.origin;
    }

    returnValue =
      window.location.protocol + "//" + returnValue + "/services/api/v2";

    return returnValue;
  },

  getChangePasswordRequired: function () {
    let returnValue = "";
    returnValue = window.sessionStorage.getItem(
      `${window.location.hostname}-coral-X-Change-Password-Required`,
    );
    return returnValue;
  },
};

const idleTimeoutValue = window.sessionStorage.getItem(
  `${window.location.hostname}-coral-X-Ideal-Timeout`,
);

const idleTimeout =
  idleTimeoutValue && idleTimeoutValue !== "" && idleTimeoutValue !== "0"
    ? parseInt(idleTimeoutValue) * 60000
    : null;

let idleTimer;

const resetIdleTimer = () => {
  if (idleTimeout !== null && idleTimeout !== 0) {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(() => {
      window.location = "/site/log-out";
    }, idleTimeout);
  }
};

if (idleTimeout !== null && idleTimeout !== 0) {
  document.addEventListener("mousemove", resetIdleTimer);
  document.addEventListener("keydown", resetIdleTimer);
  document.addEventListener("scroll", resetIdleTimer);

  window.addEventListener("load", () => {
    resetIdleTimer();
  });
}

AuthenticationService.updateSIP();

export default AuthenticationService;
